namespace TabAurous.Finance {
    export interface OpeningBalanceForm {
        TransDate: Serenity.DateEditor;
        Posted: LabelEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        PartyId: Serenity.LookupEditor;
        OpeningBalanceTypeId: Serenity.EnumEditor;
        CurrencyId: Serenity.LookupEditor;
        ExchRate: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
        CCAmount: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        IsPosted: Serenity.BooleanEditor;
        PostingDate: Serenity.DateEditor;
    }

    export class OpeningBalanceForm extends Serenity.PrefixedContext {
        static formKey = 'Finance.OpeningBalance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OpeningBalanceForm.init)  {
                OpeningBalanceForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = LabelEditor;
                var w2 = s.StringEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.EnumEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.BooleanEditor;

                Q.initFormType(OpeningBalanceForm, [
                    'TransDate', w0,
                    'Posted', w1,
                    'VoucherNo', w2,
                    'VoucherTypeId', w3,
                    'PartyId', w4,
                    'OpeningBalanceTypeId', w5,
                    'CurrencyId', w4,
                    'ExchRate', w6,
                    'Amount', w6,
                    'CCAmount', w6,
                    'Remark', w2,
                    'CompanyId', w3,
                    'FinancialYearId', w3,
                    'UserId', w3,
                    'IsPosted', w7,
                    'PostingDate', w0
                ]);
            }
        }
    }
}
